import { Pressable, Text, View } from 'react-native'

interface AdminTablePaginationProps {
  page: number
  pageCount: number
  rangeLabel: string
  previousLabel: string
  nextLabel: string
  onPreviousPage: () => void
  onNextPage: () => void
  className?: string
}

export function AdminTablePagination({
  page,
  pageCount,
  rangeLabel,
  previousLabel,
  nextLabel,
  onPreviousPage,
  onNextPage,
  className,
}: AdminTablePaginationProps) {
  const isPreviousDisabled = page <= 1
  const isNextDisabled = page >= pageCount

  return (
    <View className={`gap-3 border-t border-border sm:flex-row sm:items-center sm:justify-between ${className ?? ''}`}>
      <Text className="text-sm font-normal text-secondary">{rangeLabel}</Text>
      <View className="flex-row gap-2 sm:justify-end">
        <PaginationButton label={previousLabel} disabled={isPreviousDisabled} onPress={onPreviousPage} />
        <PaginationButton label={nextLabel} disabled={isNextDisabled} onPress={onNextPage} />
      </View>
    </View>
  )
}

interface PaginationButtonProps {
  label: string
  disabled: boolean
  onPress: () => void
}

function PaginationButton({ label, disabled, onPress }: PaginationButtonProps) {
  return (
    <Pressable
      onPress={onPress}
      disabled={disabled}
      accessibilityLabel={label}
      accessibilityRole="button"
      accessibilityState={{ disabled }}
      className={`min-h-[40px] flex-1 items-center justify-center rounded-md border border-border px-4 sm:flex-none ${
        disabled ? 'opacity-50' : ''
      }`}
    >
      <Text className="text-sm font-medium text-primary">{label}</Text>
    </Pressable>
  )
}
